<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import localizeFilter from "@/filters/localize.filter";

export default {
  metaInfo() {
    return {
      title: localizeFilter("metaTitle"),
      meta: [
        { name: "description", content: localizeFilter("metaDescription") },
        { name: "keywords", content: localizeFilter("metaKeyWords") },
        { property: "og:title", content: localizeFilter("metaTitle") },
        {
          property: "og:description",
          content: localizeFilter("metaDescription")
        },
        { property: "og:type", content: "website." },
        {
          property: "og:url",
          content: "https://arview.pro/img/icons/android-icon-192x192.png"
        },
        { property: "og:site_name", content: "Arview Company" },
        {
          property: "og:image",
          content: "https://arview.pro/img/icons/android-icon-192x192.png"
        },
        { property: "og:image:width", content: "192" },
        { property: "og:image:height", content: "192" },
        { property: "twitter:card", content: "summary" },
        {
          property: "twitter:description",
          content: localizeFilter("metaDescription")
        },
        {
          property: "twitter:image",
          content: "https://arview.pro/img/icons/android-icon-192x192.png"
        }
      ]
    };
  },
  methods: {
    getUrl(lang) {
      return this.$route.path.includes(`/${lang}`);
    },
    getLocStor() {
      return localStorage.getItem("locale");
    },
    setLocStor(lang) {
      localStorage.setItem("locale", lang);
    }
  },
  created() {
    const userLang = navigator.language || navigator.userLanguage;

    if (!this.getLocStor()) {
      if (userLang.includes("ru")) {
        this.setLocStor("ru");
      } else {
        this.setLocStor("en");
      }
    }

    if (this.getUrl("ru") && this.getLocStor() != "ru") {
      this.setLocStor("ru");
    }

    if (this.getUrl("en")) {
      this.setLocStor("en");
      this.$router.push("/");
    }

    if (this.getLocStor() == "ru" && !this.getUrl("ru")) {
      this.$router.push("/ru");
    }
  }
};
</script>